import { cn } from '@heidi/utils';

import { menuItemVariants, menuLabelClasses, menuSeparatorClasses } from '../styles';

/**
 * Experimental ContextMenu styles (DS-1197) — adopt the shared menu recipe, gated behind
 * `release-experimental-design-system-forms`. Item / checkbox / radio use
 * `menuItemVariants` directly in the component (variant/inset pass through); these hold
 * the sub-trigger, label, and separator.
 */

/** Sub-trigger = the shared item + the open-state background. */
export const contextMenuSubTriggerClassesExperimental = cn(
  menuItemVariants(),
  'data-[state=open]:bg-surface-hover data-[state=open]:text-text-primary'
);

/**
 * Checkbox / radio = the shared item with the indicator moved to the inline-end and a `Check`
 * icon for both (matches DropdownMenu's experimental check-item treatment).
 */
export const contextMenuCheckItemClassesExperimental = cn(
  menuItemVariants(),
  'pe-8 [&>span]:pointer-events-none [&>span]:end-2 [&>span]:start-auto'
);

/** Adopt the muted shared label (base is `text-sm font-semibold text-text-primary`). */
export const contextMenuLabelClassesExperimental = menuLabelClasses;

/** Semantic divider token (base already matches, but consume the shared token). */
export const contextMenuSeparatorClassesExperimental = menuSeparatorClasses;
